const LOCALHOST_HOSTNAMES = new Set([
  "localhost",
  "127.0.0.1",
]);

const AI_ENABLED_HOSTNAMES = new Set([
  "aipm.linfinityeng.com",
]);

const AI_DISABLED_HOSTNAMES = new Set([
  "pm.linfinityeng.com",
]);

const AI_ENABLED_HOST_PATTERNS = [
  /^polite-pebble-0bf8e4700\.\d+\.azurestaticapps\.net$/i,
];

const AI_DISABLED_HOST_PATTERNS = [
  /^lively-bay-0b43f3600\.\d+\.azurestaticapps\.net$/i,
];

const COMPANY_AI_VALIDATION_BASE_URL = "https://aipm.linfinityeng.com";

function normalizeHostname(hostname?: string | null): string {
  return String(
    hostname ??
    (typeof window !== "undefined" ? window.location.hostname : ""),
  )
    .trim()
    .toLowerCase();
}

function normalizeBooleanFlag(value?: string | boolean | null): boolean | null {
  if (typeof value === "boolean") {
    return value;
  }

  const normalized = String(value || "").trim().toLowerCase();
  if (!normalized) {
    return null;
  }

  if (["1", "true", "yes", "on", "enabled"].includes(normalized)) {
    return true;
  }

  if (["0", "false", "no", "off", "disabled"].includes(normalized)) {
    return false;
  }

  return null;
}

export function isCompanyAiEnabled(hostname?: string | null): boolean {
  const envOverride = normalizeBooleanFlag(import.meta.env.VITE_COMPANY_AI_ENABLED);
  if (envOverride !== null) {
    return envOverride;
  }

  const resolvedHostname = normalizeHostname(hostname);
  if (!resolvedHostname) {
    return true;
  }

  if (LOCALHOST_HOSTNAMES.has(resolvedHostname)) {
    return true;
  }

  if (AI_ENABLED_HOSTNAMES.has(resolvedHostname)) {
    return true;
  }

  if (AI_DISABLED_HOSTNAMES.has(resolvedHostname)) {
    return false;
  }

  if (AI_ENABLED_HOST_PATTERNS.some((pattern) => pattern.test(resolvedHostname))) {
    return true;
  }

  if (AI_DISABLED_HOST_PATTERNS.some((pattern) => pattern.test(resolvedHostname))) {
    return false;
  }

  return true;
}

export function isCompanyAiCutoverHost(hostname?: string | null): boolean {
  const resolvedHostname = normalizeHostname(hostname);
  if (!resolvedHostname) {
    return false;
  }

  if (AI_ENABLED_HOSTNAMES.has(resolvedHostname)) {
    return true;
  }

  return AI_ENABLED_HOST_PATTERNS.some((pattern) => pattern.test(resolvedHostname));
}

export function getCompanyAiValidationUrl(
  pathname = "/ai",
  search = "",
  hash = "",
): string {
  const normalizedPath = pathname.startsWith("/") ? pathname : `/${pathname}`;
  return `${COMPANY_AI_VALIDATION_BASE_URL}${normalizedPath}${search || ""}${hash || ""}`;
}
